import type { LevelUiStatus } from '../constants/status'

export type ProgressBarVariant = 'primary' | 'progress' | 'success' | 'locked'

export function progressVariantForUiStatus(
  status: LevelUiStatus
): ProgressBarVariant {
  if (status === 'success') return 'success'
  if (status === 'progress') return 'progress'
  if (status === 'locked') return 'locked'
  return 'primary'
}
